/**
 * Common - Footer organism
 */
// import GlobalVars from '../GlobalVars';
import { handleFbFollow } from '../molecule/social-share';


function init() {
  // Datalayer social network attractivity
  handleFbFollow();
}

export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/organism/footer.js